import './style.scss';

export function faqs_hero_block() {
  const block = document.querySelector('.faqs_hero_block');
  if (!block) return;
  
}
